import {Injectable} from '@angular/core';
import {GeneralService} from './general.service';
import {HttpClient} from '@angular/common/http';
import {UiSettingsService} from '../../shared/ui-settings.service';
import {RegoVivoMapping} from '../interfaces/regoVivoMapping';
import { SuperuserServiceModule } from '../superuser-service.module';

@Injectable({
  providedIn: SuperuserServiceModule
})
export class RegoVivoMappingService extends GeneralService<RegoVivoMapping> {

  constructor(http: HttpClient, uiSettingService: UiSettingsService) {
    super(http, uiSettingService, 'regovivomappings', 'regovivomapping', 'rego');
  }
}
